export default __webpack_public_path__ + "static/media/ill-no-data.55f7ec22.svg";